import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography } from '@mui/material'
import React from 'react'
import { useFormFactor } from '../../../hooks'
import { useStyles } from './../styles'

const ProfileSectionContainer = ({
  id,
  sectionTitle,
  children
}) => {
  const classes = useStyles()

  const { isDesktop, isLargeTablet } = useFormFactor()

  const isLargeScreen = isDesktop || isLargeTablet

  const title = <Typography className={classes.profileSectionTitle} style={{ marginBottom: isLargeScreen && '8px' }} component='h2'>{sectionTitle}</Typography>

  if (isLargeScreen) {
    return (
      <Box typeof='section' id={id} data-test={id} className={classes.profileSectionContainer} mt={2}>
        {title}
        <Divider className={classes.profileSectionDivider} />
        <Box mt={2} mb={3}>
          {children}
        </Box>
      </Box>
    )
  }

  const contentId = `${id}-content`

  return (
    <Accordion mt={2} mb={2} className={classes.accordion}>
      <AccordionSummary
        aria-controls={contentId}
        id={`${id}-header`}
        expandIcon={<ExpandMoreIcon className={classes.accordionPrimaryIcon} />}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails id={contentId} className={classes.accordionDetails}>
        <Box mt={1} mb={1} display='flex' flex={1} flexDirection='column'>
          {children}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default ProfileSectionContainer
